export default {
  showHidden: 'Pokaż ukryte sygnały',
  deselectAll: 'Odznacz wszystko',
  newSignal: 'Nowy sygnał wirtualny',
};
